import React from 'react';
import './select-defense.css';
import classData from '../../datasets/class-detail.json';
import Options from "../../components/options/options";
import socketService from "../../services/socket";
import Icon from "../../components/icon/icon";

function SelectDefense({classSelected, roomCode, enemyAttack}) {
    const selectedClass = classData.classes.find(cls => cls?.nome?.toLowerCase() === classSelected?.nome.toLowerCase());

    return (
        <div className="your-turn">
            <h3>É seu turno, selecione a defesa:</h3>
            {selectedClass && selectedClass.defesas.map((ataque, index) => (
                <Options method={() => {
                    socketService.emit('defend', { roomCode, defenseIndex: index });
                }}>
                    <div>
                        {ataque.nome} <br/>
                        <Icon icon={'magic_defense'} style={{width: 15}} title={ataque.reducao_dano_magico} />
                        <Icon icon={'shield'} style={{width: 15}} title={ataque.reducao_dano_fisico} />
                    </div>
                </Options>
            ))}
            <div style={{paddingTop: '130px'}}>
                <h3>Ataque inimigo:</h3>
                {enemyAttack.nome} <br/>
                {enemyAttack.descricao} <br/>
                <Icon icon={'magic'} style={{width: 15}} title={enemyAttack.dano_magico} />
                <Icon icon={'sword'} style={{width: 15}} title={enemyAttack.dano_fisico} />
            </div>
        </div>
    );
}

export default SelectDefense;